import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import {Tab, Tabs} from 'material-ui/Tabs';

import {closeNotificationForm, updateNotificationField, updateReminderField, updateNotification, displayError} from '../../actions/events'

import moment from 'moment'

const customContentStyle = {
  maxWidth: '500px',
  minWidth: '300px',
};

class UpdateNotifications extends Component {

  static defaultProps = {

  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeNotificationForm())
  }

  updateNotification() {
    const { dispatch } = this.props

    if (!this.props.notification.message || this.props.notification.message.length === 0) {
      return dispatch(displayError("Notification message is mandatory!"))
    }

    if (!this.props.notification.scheduledDate) {
      return dispatch(displayError("Please select a scheduled date for the notification!"))
    }

    dispatch(updateNotification(this.props.notification, this.props.eventInfo))
  }

  updateReminder() {

    const { dispatch } = this.props

    if (!this.props.reminder.message || this.props.reminder.message.length === 0) {
      return dispatch(displayError("Reminder message is mandatory!"))
    }

    if (!this.props.reminder.alert || this.props.reminder.alert.length === 0) {
      return dispatch(displayError("Please select the alert interval for the reminder!"))
    }

    dispatch(updateNotification(this.props.reminder, this.props.eventInfo))
  }

  updateNotificationDate(name, notification, date) {

    const { dispatch } = this.props
    var newDate = moment(date)

    if (this.props.notification.scheduledDate) {
      var notificationDate = moment(this.props.notification.scheduledDate)

      notificationDate.date(newDate.date())
      notificationDate.month(newDate.month())
      notificationDate.year(newDate.year())

      newDate = notificationDate
    }

    dispatch(updateNotificationField(name, newDate.toDate().toString()))
  }

  updateNotificationTime(name, notification, time) {
    const { dispatch } = this.props
    var newDate = moment(time)

    if (this.props.notification.scheduledDate) {
      var notificationDate = moment(this.props.notification.scheduledDate)

      notificationDate.hours(newDate.hours())
      notificationDate.minutes(newDate.minutes())

      newDate = notificationDate
    }

    dispatch(updateNotificationField(name, newDate.toDate().toString()))
  }

  updateNotificationField(event) {
    const { dispatch } = this.props
    dispatch(updateNotificationField(event.target.name, event.target.value))
  }

  updateReminderField(event) {
    const { dispatch } = this.props
    dispatch(updateReminderField(event.target.name, event.target.value))
  }

  render() {

    if (this.props.notification && this.props.reminder && this.props.eventInfo) {

      return (<Dialog
        contentStyle={customContentStyle}
        autoScrollBodyContent={true}
        autoDetectWindowHeight={true}
        modal={true}
        open={this.props.notification != null}>
          <Tabs>
            <Tab label="Event Notification">
              <div>
                <br/>
                <DatePicker
                  hintText="Notification Date"
                  name="scheduledDate"
                  value={this.props.notification.scheduledDate ? new Date(this.props.notification.scheduledDate) : null}
                  onChange={this.updateNotificationDate.bind(this, "scheduledDate")}
                />
                <TimePicker
                  name="scheduledTime"
                  format="ampm"
                  hintText="Notification Time"
                  value={this.props.notification.scheduledDate ? new Date(this.props.notification.scheduledDate) : null}
                  onChange={this.updateNotificationTime.bind(this, 'scheduledDate')}
                />
                <br/>
                <TextField
                  fullWidth={true}
                  name="message"
                  hintText="Notification Message"
                  floatingLabelText="Notification Message"
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  value={this.props.notification.message}
                  onChange={this.updateNotificationField.bind(this)}
                />

                <FlatButton
                  label="Cancel"
                  primary={true}
                  onClick={this.closeDialog.bind(this)}
                />
                <FlatButton
                  label="Update Notification"
                  primary={true}
                  onClick={this.updateNotification.bind(this)}
                />,
              </div>
            </Tab>
            <Tab label="Event Reminder">
              <div>
                <br/>
                <TextField
                  fullWidth={true}
                  name="alert"
                  hintText="Reminder Alert"
                  floatingLabelText="Number of minutes before the events starts"
                  value={this.props.reminder.alert}
                  onChange={this.updateReminderField.bind(this)}
                />
                <br/>
                <TextField
                  fullWidth={true}
                  name="message"
                  hintText="Reminder Message"
                  floatingLabelText="Reminder Message"
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  value={this.props.reminder.message}
                  onChange={this.updateReminderField.bind(this)}
                />

                <FlatButton
                  label="Cancel"
                  primary={true}
                  onClick={this.closeDialog.bind(this)}
                />
                <FlatButton
                  label="Update Reminder"
                  primary={true}
                  onClick={this.updateReminder.bind(this)}
                />
            </div>
          </Tab>
        </Tabs>
        <div style={{color: "red"}}>{this.props.error}</div>
      </Dialog>)
    } else {
      return (<div />)
    }

  }
}

const mapStateToProps = state => {
  return state.eventsReducer
}

export default withRouter(
  connect(mapStateToProps)(UpdateNotifications)
);



// WEBPACK FOOTER //
// ./src/components/events/UpdateNotifications.js